/**
 * POS View Switcher Component - Minimal Toggle Switch
 * Floating switch at bottom-left corner
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const POSViewSwitcher: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isModern = location.pathname === '/pos/modern' || location.pathname === '/' || location.pathname === '/pos' || location.pathname === '/cashier';
  
  const toggleView = () => {
    navigate(isModern ? '/pos/classic' : '/pos/modern');
  };
  
  return (
    <button
      onClick={toggleView}
      className="fixed bottom-6 left-6 z-50 w-14 h-8 rounded-full transition-all hover:scale-110 shadow-lg"
      style={{
        background: isModern 
          ? 'linear-gradient(to right, #3b82f6, #8b5cf6)' 
          : '#eab308'
      }}
      title={isModern ? 'Switch to Classic Mode' : 'Switch to Modern Mode'}
    >
      <div
        className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-md transition-all flex items-center justify-center ${
          isModern ? 'left-1' : 'left-7'
        }`}
      >
        <span className="text-xs">{isModern ? '🌙' : '☀️'}</span>
      </div>
    </button>
  );
};

export default POSViewSwitcher;
